import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const startPoint = 0;
const body = document.querySelector('body');
const onHistoryChange = () => {
    window.scrollTo(startPoint, startPoint);
    body.scrollTo(startPoint, startPoint);
};

const ScrollToTop = ({ history }) => {
    useEffect(() => {
        history.listen(() => onHistoryChange());

        return () => onHistoryChange();
    }, []);

    return null;
};

export default withRouter(ScrollToTop);
